export default {"src":"/_next/static/media/commercetools.29fbf6ec.svg","height":68,"width":248,"blurWidth":0,"blurHeight":0};